import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TEXT_CONSTANTS } from '../../constants/text-constants';
import { getTagColorClass } from '../../utils/tag-colors.util';

@Component({
  selector: 'tags-addon',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './tags-addon.component.html',
})
export class TagsAddonComponent implements OnInit {
  TEXT = TEXT_CONSTANTS;

  @Input() initialTags: string[] = [];
  @Input() suggestions: string[] = [];
  /** `'dropdown'` = absolute overlay under the input; `'inline'` = suggestion chips in normal flow. */
  @Input() suggestionsMode: 'dropdown' | 'inline' = 'dropdown';
  @Output() tagsChange = new EventEmitter<string[]>();
  @Output() remove = new EventEmitter<void>();
  @Output() change = new EventEmitter<void>();

  tags: string[] = [];
  tagInput = '';
  tagSuggestionQuery = '';
  showTagSuggestions = false;

  ngOnInit(): void {
    this.tags = [...this.initialTags];
  }

  get filteredTagSuggestions(): string[] {
    return this.suggestions
      .filter(tag => !this.tags.includes(tag))
      .filter(tag => !this.tagSuggestionQuery || tag.toLowerCase().includes(this.tagSuggestionQuery));
  }

  /** Capped suggestion list for the inline (chips) layout. */
  get inlineSuggestions(): string[] {
    return this.filteredTagSuggestions.slice(0, 12);
  }

  tagColor(tag: string): string {
    return getTagColorClass(tag);
  }

  addTag(): void {
    const value = this.tagInput.trim();
    if (value && !this.tags.includes(value)) {
      this.tags.push(value);
      this.tagsChange.emit([...this.tags]);
      this.change.emit();
    }
    this.tagInput = '';
    this.tagSuggestionQuery = '';
    this.showTagSuggestions = false;
  }

  removeTag(index: number): void {
    if (index >= 0 && index < this.tags.length) {
      this.tags.splice(index, 1);
      this.tagsChange.emit([...this.tags]);
    }
  }

  handleTagInputKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.addTag();
    } else if (event.key === 'Backspace' && this.tagInput === '' && this.tags.length > 0) {
      this.removeTag(this.tags.length - 1);
    }
  }

  onTagInputChange(): void {
    this.tagSuggestionQuery = this.tagInput.trim().toLowerCase();
    this.showTagSuggestions = this.tagSuggestionQuery.length > 0 || this.filteredTagSuggestions.length > 0;
    this.change.emit();
  }

  selectTagSuggestion(tag: string): void {
    if (!this.tags.includes(tag)) {
      this.tags.push(tag);
      this.tagsChange.emit([...this.tags]);
    }
    this.tagInput = '';
    this.tagSuggestionQuery = '';
    this.showTagSuggestions = false;
    this.change.emit();
  }

  hideTagSuggestions(): void {
    setTimeout(() => { this.showTagSuggestions = false; }, 200);
  }
}
